import { createLogger } from '@ctrl-enter/tools/utils';

const logger = createLogger('web');

/**
 * Web client environment configuration
 * Uses Vite's import.meta.env for environment variables
 */

// Web-specific environment variables (using Vite's import.meta.env)
export const WORKOS_CLIENT_ID = import.meta.env.VITE_WORKOS_CLIENT_ID || '';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
export const STRIPE_PRICING_TABLE_ID = import.meta.env.VITE_STRIPE_PRICING_TABLE_ID || '';
export const STRIPE_SUBSCRIPTION_PORTAL_URL =
  import.meta.env.VITE_STRIPE_SUBSCRIPTION_PORTAL_URL || '';
export const SUBSCRIPTION_ENTITLEMENT_NAME =
  import.meta.env.VITE_SUBSCRIPTION_ENTITLEMENT_NAME || 'has_subscription';
export const API_PUBLIC_KEY = import.meta.env.VITE_API_PUBLIC_KEY || '';
export const OPENAI_API_KEY = import.meta.env.VITE_OPENAI_API_KEY || '';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || '';
export const CONFIGURATION_MODE = import.meta.env.VITE_CONFIGURATION_MODE || '';

// OpenAI Text-to-Speech configuration
export const ENABLE_OPENAI_TTS = (import.meta.env.VITE_ENABLE_OPENAI_TTS || 'true') === 'true';
export const OPENAI_TTS_DEFAULT_VOICE = import.meta.env.VITE_OPENAI_TTS_DEFAULT_VOICE || 'nova';

// Widget token testing tools (development only)
export const ENABLE_WIDGET_TOKEN_TEST_TOOLS =
  (import.meta.env.VITE_ENABLE_WIDGET_TOKEN_TEST_TOOLS || 'false') === 'true';

export const isProduction = import.meta.env.PROD;
export const isDevelopment = import.meta.env.DEV;

logger.info('🔄 [ENV] Web environment variables:', {
  WORKOS_CLIENT_ID,
  API_BASE_URL,
  STRIPE_PUBLISHABLE_KEY,
  API_PUBLIC_KEY,
  OPENAI_API_KEY,
  isProduction,
  isDevelopment,
  CONFIGURATION_MODE,
});
